import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const CallbackHandler = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { handleCallback } = useAuth();
  const [processing, setProcessing] = useState(true);
  const [error, setError] = useState(null);
  
  useEffect(() => {
    const processCallback = async () => {
      console.log('CallbackHandler: Processing callback');
      console.log('URL search params:', Object.fromEntries(searchParams));
      
      const code = searchParams.get('code');
      const error = searchParams.get('error');
      const errorDescription = searchParams.get('error_description');
      
      // Check for OAuth error first
      if (error) {
        console.error('OAuth error:', error, errorDescription);
        setError(`Authentication failed: ${error} - ${errorDescription || 'Unknown error'}`);
        setProcessing(false);
        setTimeout(() => navigate('/login'), 3000);
        return;
      }
      
      // Check for authorization code
      if (!code) {
        console.error('No authorization code received');
        setError('No authorization code received from Cognito');
        setProcessing(false);
        setTimeout(() => navigate('/login'), 3000);
        return;
      }
      
      // Process the authorization code
      try {
        console.log('CallbackHandler: Handling callback with code');
        const success = await handleCallback(code);
        
        if (success) {
          console.log('CallbackHandler: Authentication successful, redirecting to dashboard');
          navigate('/dashboard');
        } else {
          console.error('CallbackHandler: Authentication failed');
          setError('Failed to complete authentication');
          setProcessing(false);
          setTimeout(() => navigate('/login'), 3000);
        }
      } catch (err) {
        console.error('CallbackHandler: Exception during callback processing:', err);
        setError(`Authentication error: ${err.message}`);
        setProcessing(false);
        setTimeout(() => navigate('/login'), 3000);
      }
    };
    
    // Add a small delay to ensure all URL params are loaded
    const timeoutId = setTimeout(processCallback, 100);
    
    return () => clearTimeout(timeoutId);
  }, [searchParams, handleCallback, navigate]);
  
  if (error) {
    return (
      <div className="callback-container">
        <div className="error-message">
          <h2>Authentication Error</h2>
          <p>{error}</p>
          <p>Redirecting to login page...</p>
          <button 
            onClick={() => navigate('/login')} 
            className="retry-button"
          >
            Go to Login Now
          </button>
        </div>
      </div>
    );
  }
  
  return (
    <div className="callback-container">
      <div className="loading">
        <h2>Processing Authentication...</h2>
        <p>Please wait while we complete your login.</p>
        <div className="spinner">⏳</div>
      </div>
    </div>
  );
};

export default CallbackHandler;